import React, { memo } from 'react'

import Autocomplete from '@ublique/components/Autocomplete'
import { Column, Row } from '@ublique/components/Grid'

import MailTo from './MailTo'
import { isInvalidByField } from '../utils/form'
// import { getJobTypes } from '../utils/options'
import { JOB_TYPE } from '../constants'
import InfoButton from './InfoButton'

const JobData = ({
  t,
  jobType,
  mailTo,
  jobTypes,
  setFieldValue,
  submitted
}) => {
  // const jobTypes = getJobTypes()
  const getHandleJobTypeChange = (value) => setFieldValue(JOB_TYPE, value)

  return (
    <>
      <Row className='line-title-row'>
        <h5 className='creation-subtitle'>{t('JobData.HEADING')}</h5>
        <InfoButton message={t('JobData.TOOLTIP')} />
      </Row>
      <Row>
        <Column md={8}>
          <Autocomplete
            id='job-type'
            valueKey='value'
            defaultValue={{ value: jobType, label: jobType }}
            labelKey='label'
            searchKey='label'
            items={jobTypes}
            labelText={t('JobData.JOB_TYPE')}
            placeholder={t('Placeholder')}
            invalidText={t('JobData.JOB_TYPE_REQUIRED')}
            onChange={getHandleJobTypeChange}
            invalid={isInvalidByField.jobType({ value: jobType, submitted })}
          />
        </Column>
      </Row>
      <MailTo
        t={t}
        mailTo={mailTo}
        setFieldValue={setFieldValue}
        submitted={submitted}
      />
    </>
  )
}

export default memo(JobData)
